  $(document).ready(function(){
      $('body').on('click', '.faq-single', function(e){
        e.preventDefault();

        //Hide all
        if(!$(this).find('.plus-icon').hasClass('active')){
          $(".faq-single").find('.question-seo-contents').removeClass('active');
          $(".faq-single").find('.plus-icon, .negative-icon').removeClass('active');
          $(".faq-single").find('.answer-seo-contents').hide();  
        }
        
        //Hide all end
        
        if($(this).find('.question-seo-contents').hasClass('active')){
          $(this).find('.question-seo-contents').removeClass('active');
        } else{
          $(this).find('.question-seo-contents').addClass('active');          
        }

        if($(this).find('.plus-icon').hasClass('active')){
          $(this).find('.plus-icon, .negative-icon').removeClass('active');
        } else{          
          $(this).find('.plus-icon, .negative-icon').addClass('active');
        }

        if($(this).find('.answer-seo-contents').css('display') == 'block'){
          $(this).find('.answer-seo-contents').hide();
        } else{ 
          $(this).find('.answer-seo-contents').show();          
        }
      })
    })